<script lang="ts">
	import Icon from '$lib/components/Icon/Icon.svelte';

	export let onChange: (id: number) => void;

	let selected = 0;

	const move = (direction: 'left' | 'right'): void => {
		if (direction === 'left') {
			if (selected <= 0) {
				selected = 2;
			} else {
				selected = selected - 1;
			}
		} else {
			if (selected >= 2) {
				selected = 0;
			} else {
				selected = selected + 1;
			}
		}
		onChange(selected);
	};

	const change = (id: number): void => {
		selected = id;
		onChange(selected);
	};
</script>

<div class="selector">
	<button type="button" on:click={() => move('left')}>
		<Icon icon="left-chevron" />
	</button>
	{#each [0, 1, 2] as i}
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<span class:selected={selected === i} on:click={() => change(i)} class="dot" />
	{/each}
	<button type="button" on:click={() => move('right')}>
		<Icon icon="right-chevron" />
	</button>
</div>

<style>
	.selector {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	button {
		block-size: 4rem;
		border: none;
	}

	.dot {
		display: inline-block;
		block-size: 1.5rem;
		inline-size: 1.5rem;
		border-radius: 50%;
		background-color: var(--grayLight);
	}

	.selected {
		background-color: var(--blueLight);
	}
</style>
